type ChatbotInstance = {
  closeChat: () => void
  showChatButton: () => void
  hideChatButton: () => void
}

const BebridgeAIChatbot = (userId: string): Promise<ChatbotInstance | null> => {
  return new Promise(resolve => {
    if (typeof window !== 'undefined') {
      const loadSDK = () => {
        if (window.BebridgeAIChatbotInitialized) {
          resolve(window.BebridgeAIChatbotInstance || null)
          return
        }

        window.BebridgeAIChatbotInitialized = true

        const script = document.createElement('script')
        script.type = 'text/javascript'
        script.async = true
        script.src = window.bebridgeChatbotUrl
        script.charset = 'UTF-8'
        document.head.appendChild(script)

        script.onload = () => {
          if (window.BebridgeAIChatbot) {
            const { BebridgeAIChat } = window.BebridgeAIChatbot

            if (BebridgeAIChat) {
              BebridgeAIChat.init({
                pluginKey: window.bebridgeChatbotPluginKey,
              })

              const chatbotInstance = new BebridgeAIChat()

              chatbotInstance.render({
                userKey: userId,
                botKey: window.bebridgeChatbotBotKey,
                hideDefaultChatButton: true,
              })

              window.BebridgeAIChatbotInstance = chatbotInstance
              resolve(chatbotInstance)
            } else {
              console.error('BebridgeAIChat is not available.')
              resolve(null)
            }
          } else {
            console.error('BebridgeAIChatbot is not available on the window object.')
            resolve(null)
          }
        }
      }

      if (document.readyState === 'complete') {
        loadSDK()
      } else {
        window.addEventListener('load', loadSDK)
      }
    } else {
      console.error('Window object is not available.')
      resolve(null)
    }
  })
}

export default BebridgeAIChatbot
